import api from 'utils/apiClient';

export const getUsers = (params) => {
  return api.get('/users', { params });
};

export const getUser = (id) => {
  return api.get(`/users/${id}`);
};

export const createUser = (data) => {
  return api.post('/users', data);
};

export const editUser = (id, data) => {
  return api.patch(`/users/${id}`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    },
  });
};

export const blockUser = (id, data) => {
  return api.patch(`/users/${id}/ban`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
      Accept: 'application/json',
    },
  });
};

export const unblockUser = (id) => {
  return api.patch(
    `/users/${id}/unban`,
    {},
    {
      headers: {
        'Content-Type': 'application/merge-patch+json',
        Accept: 'application/json',
      },
    },
  );
};

export const bulkBlockUsers = (ids, data = {}) => {
  return api.patch(`/users/ban?items=${ids.join(',')}`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
      Accept: 'application/json',
    },
  });
};

export const bulkUnblockUsers = (ids) => {
  return api.patch(
    `/users/unban?items=${ids.join(',')}`,
    {},
    {
      headers: {
        'Content-Type': 'application/merge-patch+json',
        Accept: 'application/json',
      },
    },
  );
};

export const deleteUser = (id) => {
  return api.delete(`/users/${id}`);
};

export const bulkDeleteUsers = (ids) => {
  return api.delete(`/users?items=${ids.join(',')}`);
};

export const convertFake = (id, data) => {
  return api.patch(`/users/${id}/fake_convert`, data, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
      Accept: 'application/json',
    },
  });
};
